import { GutterSection } from "@/commons/interface/building/gutter-section"
import classNames from "classnames";
import { graphicStore } from "@/commons/store/graphic-store";
import { ARCHI_CTRL_TYPE } from "@/passets/archibase-engine/enums/archibase-control-type";
import { PlineT } from "pytha";
import { ARCHI_SUB_CONTROL } from "@/passets/archibase-engine/enums/archi-sub-control";
import { useParams } from "react-router";
import TnMessage from "@/commons/widget/message";
import PlaceButton from "@/commons/widget/place-button";
interface Iprops {
    item: GutterSection
    selected: boolean // 是否处于选中状态
}

export default function GutterDisplayItem(props: Iprops) {

    const { item } = props;

    const { projectUuid, modelUuid } = useParams()

    // 直接布置
    const onAssemble = () => {
        if (!item.entity) {
            TnMessage.warning("缺少天沟截面，请先绘制");
            return;
        }
        let section = new PlineT().fromJson(item.entity)
        // 激活布置天沟的二级控制器
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== ARCHI_CTRL_TYPE.ASSIGN_GUTTER) {
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.ASSIGNGUTTERCONTROL.name);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.setInitControlData.dispatch({ originPlineT: section, projectUuid: projectUuid, modelUuid: modelUuid });
        }
    }

    return (
        <div className="gutter-item">
            <div className={classNames({
                "name": true,
                "selected": props.selected,
            })}>
                <div className="text ellipsis">{item.name}</div>
                <PlaceButton onClick={onAssemble} />
            </div>
        </div>
    )
}